import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { hudMachinesApiCRUDUrl } from '../../constants/apis/hud_apis';

export const getHudMachines = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudMachinesApiCRUDUrl, config);
    return response;
};
